module.exports = "/_next/static/images/Trend05Visual-33f88ebff0ea08891f6d17bb3bccf31f.png";